import { useContext } from 'react'
import ContextStates from '../context/ContextStates';
import Layout from '../components/Layout'
import FormVentas from '../components/forms/formVentas';
import FormJornadas from '../components/formJornadas';
import Customer from '../components/customer';

const Index = () => {
    const { estadoJornada, roles, idUsuario } = useContext(ContextStates)
    return (
        <Layout
            pagina="Inicio"
        >
            <main className='h-full'>
                <div className='w-full h-full bg-white'>
                    {idUsuario !== 0 ? (
                        <>
                            {roles.includes("1") || roles.includes("10") || roles.includes("11") || roles.includes("21") || roles.includes("40") || roles.includes("41") || roles.includes("42") ? (
                                <>
                                    {estadoJornada === 0 ? (
                                        <FormJornadas />
                                    ) : (
                                        <FormVentas />
                                    )}
                                </>
                            ) : (
                                <Customer />
                            )}
                        </>
                    ) : (
                        <Customer />
                    )}
                </div>
            </main>

        </Layout>
    )
}

export default Index